// Internal modules
import { dispatchFormAction } from '@/store';
import type { NoneAddressInputs } from '@/store/models/form/types';

const selectAllChangeHandler = (
  ev: React.MouseEvent | React.KeyboardEvent,
  newValue: boolean,
  affectedFields: Array<keyof NoneAddressInputs>,
): void => {
  ev.persist();

  const newPayload = {
    displayError: false,
    error: '',
    errorCode: '',
    isDirty: true,
    isValid: newValue,
    value: newValue,
  };

  // Fields to involve in the handler
  affectedFields.forEach(fieldKey => {
    dispatchFormAction({
      field: fieldKey,
      payload: newPayload,
    });
  });
};

export { selectAllChangeHandler };
